module.exports = __webpack_public_path__ + "static/media/0224_IMG_LE_SOL_CARRELAGE_EXISTANT.70eb8df9.png";